import { Text, tokens } from "@fluentui/react-components";
import React from "react";
import { getTimeAndDate } from "utils/generalUtils";
import { IMessageCommentProps } from "./MessageComment.types";

export const containerStyle = {
    backgroundColor: "#f0f0f0",
    padding: "10px",
    marginTop: "8px",
    borderRadius: "6px"
} as React.CSSProperties;

export const dateStyle = {
    padding: "0px 0px 0px 5px",
    color: tokens.colorNeutralForeground3,
    marginTop: "4px"
} as React.CSSProperties

export const MessageComment = (props: IMessageCommentProps) => {
    return (
        <div style={containerStyle}>
            <Text block>{props.comment.content}</Text>
            <Text italic size={100} style={{ color: "#666", marginTop: "6px" }}>
                {props.comment.displayName}
            </Text>
            <Text
                italic
                size={100}
                style={dateStyle}
            >
                {getTimeAndDate(props.comment.createdAt)}
            </Text>
        </div >
    );
};